import { Directive, Inject, ElementRef, Input, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { AmdMediaQueryService } from '../utilities/media-query/media-query.service';
import { AmdScrollService } from '../utilities/scroll/scroll.service';
export class AmdParallaxDirective {
    /**
     * @param {?} document
     * @param {?} elementRef
     * @param {?} mediaQueryService
     * @param {?} scrollService
     * @param {?} renderer
     */
    constructor(document, elementRef, mediaQueryService, scrollService, renderer) {
        this.document = document;
        this.elementRef = elementRef;
        this.mediaQueryService = mediaQueryService;
        this.scrollService = scrollService;
        this.renderer = renderer;
        this.setScrollPosition = (scrollPosition) => {
            this.renderer.setStyle(this.elementRef.nativeElement, 'transform', `translate3d(0, ${scrollPosition * this.scale}px, 0)`);
        };
        this.resetScrollPosition = () => {
            this.setScrollPosition(0);
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.mediaQueryService.$mediaQuery.subscribe(this.checkDevice.bind(this));
        this.scrollService.$windowScroll.subscribe(this.onScroll.bind(this));
        this.renderer.setStyle(this.elementRef.nativeElement, 'position', 'relative');
        this.renderer.setStyle(this.elementRef.nativeElement, 'z-index', '-1');
    }
    /**
     * @return {?}
     */
    checkDevice() {
        this.isParallaxEnabled =
            this.mediaQueryService.checkMediaQuery('gt-sm') &&
                !this.mediaQueryService.isIe() &&
                !this.mediaQueryService.isEdge(); // [TODO] - Fix scrolling on IE and Edge, http://brospars.github.io/snippets/ie-jumpy-bg 
        if (!this.isParallaxEnabled) {
            this.resetScrollPosition();
        }
        else {
            this.setScrollPosition(this.getScrollTop());
        }
    }
    /**
     * @return {?}
     */
    onScroll() {
        if (!this.isParallaxEnabled) {
            return;
        }
        this.setScrollPosition(this.getScrollTop());
    }
    /**
     * @return {?}
     */
    getScrollTop() {
        return this.document.documentElement.scrollTop || this.document.body.scrollTop;
    }
}
AmdParallaxDirective.decorators = [
    { type: Directive, args: [{
                selector: '[amdParallax]'
            },] },
];
/**
 * @nocollapse
 */
AmdParallaxDirective.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
    { type: ElementRef, },
    { type: AmdMediaQueryService, },
    { type: AmdScrollService, },
    { type: Renderer2, },
];
AmdParallaxDirective.propDecorators = {
    'scale': [{ type: Input },],
};
function AmdParallaxDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdParallaxDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdParallaxDirective.ctorParameters;
    /** @type {?} */
    AmdParallaxDirective.propDecorators;
    /** @type {?} */
    AmdParallaxDirective.prototype.scale;
    /** @type {?} */
    AmdParallaxDirective.prototype.isParallaxEnabled;
    /** @type {?} */
    AmdParallaxDirective.prototype.setScrollPosition;
    /** @type {?} */
    AmdParallaxDirective.prototype.resetScrollPosition;
    /** @type {?} */
    AmdParallaxDirective.prototype.document;
    /** @type {?} */
    AmdParallaxDirective.prototype.elementRef;
    /** @type {?} */
    AmdParallaxDirective.prototype.mediaQueryService;
    /** @type {?} */
    AmdParallaxDirective.prototype.scrollService;
    /** @type {?} */
    AmdParallaxDirective.prototype.renderer;
}
//# sourceMappingURL=parallax.directive.js.map
//# sourceMappingURL=parallax.directive.js.map
